"use client";

import { useCallback, useEffect, useState } from "react";

export function useHashParams() {
  const [hashParams, setParams] = useState<Record<string, string>>({});

  const parseHash = useCallback(() => {
    const hash = window.location.hash.slice(1); // Remove the '#'
    const searchParams = new URLSearchParams(hash);
    const newParams: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      newParams[key] = value;
    });
    setParams(newParams);
  }, []);

  useEffect(() => {
    // Parse initial hash
    parseHash();

    // Listen for hash changes
    window.addEventListener("hashchange", parseHash);

    // Cleanup
    return () => {
      window.removeEventListener("hashchange", parseHash);
    };
  }, [parseHash]);

  const setHashParams = useCallback((newParams: Record<string, string>) => {
    const searchParams = new URLSearchParams(window.location.hash.slice(1));
    Object.entries(newParams).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value);
      } else {
        searchParams.delete(key);
      }
    });
    window.location.hash = searchParams.toString();
  }, []);

  return { hashParams, setHashParams };
}
